<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex xs12 sm6 lg4 v-for="(post, index) in posts" :key="index">
        <v-card class="elevation-8 ma-1 post-card">
          <v-card-media :src="getRandomImage(post.attachments)" height="160" />
          <v-card-title primary-title class="pb-0">
            <div>
              <h3 class="post-card-title subheading ma-0 grey--text text--darken-1" v-html="post.title" />
            </div>
          </v-card-title>
          <v-card-text class="pb-0 post-excerpt" v-html="cap(post.excerpt)" />
          <v-card-actions>
            <v-btn raised :color="baseColor" block router :to="createPostUrl(post.date, post.slug)" v-html="$store.getters.getLangKey('readFullPost')" />
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <vue-adsense ad-slot="8238948290" ad-format="auto" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Mixins from '../helpers/Mixins'

  export default {
    name: 'LatestPosts',
    mixins: [
      Mixins
    ],
    data () {
      return {
        posts: this.$store.state.bootstrapData.recentPosts || [],
        baseColor: this.$store.state.baseColor,
        images: [
          'javascript',
          'html',
          'css',
          'code',
          'angular'
        ]
      }
    },
    methods: {
      /**
       * Get a ramdom image if there is no attachment in the DTO
       * @method getRandomImage
       * @param {Array} attachments
       * @return {String}
       * **/
      getRandomImage (attachments) {
        const images = this.images
        const random = images[Math.floor(Math.random() * images.length)]
        const url = attachments.length ? attachments[0].url : `https://loremflickr.com/320/240/${random}`
        return url
      }
    }
  }
</script>
<style>
.post-card .post-card-title
{
  height: 66px;
  overflow: hidden;
}

.post-card .card__text p
{
  height: 210px;
  margin: 0;
}

.post-card .post-excerpt
{
  height: 76px;
}
</style>



// WEBPACK FOOTER //
// src/components/LatestPosts.vue